import { Parchment } from 'quill/core';

class HeaderId extends Parchment.Attributor {
  constructor(attrName = 'header-id', keyName = 'header-id') {
    super(attrName, keyName, { scope: Parchment.Scope.BLOCK });
  }
}

export default new HeaderId();
